import styled from 'styled-components';
import Row from './row';

const DateRow = styled(Row)`
  background-color: white;
  border-bottom: 1px solid var(--grey300);
`;

export default DateRow;
